exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__menuButton___2ZZ-R {\n  position: absolute;\n  right: 10px;\n  top: 4px; }\n  .style__menuButton___2ZZ-R .arrow {\n    display: none; }\n  .style__menuButton___2ZZ-R button {\n    border: none; }\n\n.style__menu___pb_Bt {\n  list-style: none;\n  padding: 0;\n  margin: 0; }\n  .style__menu___pb_Bt li {\n    padding: 5px 10px;\n    cursor: pointer; }\n    .style__menu___pb_Bt li:hover {\n      color: #262626;\n      background-color: #f5f5f5; }\n\n.popover.style__popover___2tkHS .arrow {\n  display: none; }\n\n.popover-content.style__popover___2tkHS {\n  padding: 10px 0; }\n\n.style__toggle___3VpWr {\n  display: inline-block;\n  font-size: 20px;\n  height: 24px;\n  line-height: 24px;\n  transition: transform 300ms; }\n\n.style__toggleActive___2k43e {\n  transform: rotateZ(90deg); }\n", ""]);

// exports
exports.locals = {
	"menuButton": "style__menuButton___2ZZ-R",
	"menu": "style__menu___pb_Bt",
	"popover": "style__popover___2tkHS",
	"toggle": "style__toggle___3VpWr",
	"toggleActive": "style__toggleActive___2k43e"
};